<template>
  <article class="col-12 py-5 border-bottom">
    <StoCscResultItemHeader
      v-bind:name="item.productData.name"
      v-bind:serial="item.productData.serialNumber"
      v-bind:pdf="item.pdf"
    />
    <section class="row">
      <StoCscResultItemAside
        v-bind:image="item.image"
      />
      <StoCscResultItemComposition
        v-bind:construction="item.productData.construction"
      />
    </section>
    <StoCscResultItemTechnicalValues
      v-bind:technicalValues="item.productData.technicalValues"
    />
  </article>
</template>

<script>

import StoCscResultItemHeader from './Header.vue'
import StoCscResultItemAside from './Aside.vue'
import StoCscResultItemComposition from './Composition.vue'
import StoCscResultItemTechnicalValues from './TechnicalValues.vue'

export default {
  name: 'StoCscResultItemGrid',
  props: {
    item: Object
  },
  components: {
    StoCscResultItemHeader,
    StoCscResultItemAside,
    StoCscResultItemComposition,
    StoCscResultItemTechnicalValues
  }
}

</script>
